export function generalizeTableClaimJSON(table_data) {
  const newArray = table_data.map((obj) => {
    const keyMap = {
      Effective_Date: "Effective Date",
      Provider_Name: "Provider name",
      tax_id: "Tax ID",
      Submit_Claims: "Submit Claims Duration",
      participating_lines_of_business: "Participating Lines of Business",
      CPT_Code: "CPT Code",
      Description: "Description",
      Rate: "Rate",
      cob_provision: "COB provision",
      provider_name_effective_date: "Provide Name / Effective Date",
      submit_claims_description: "Submit Claims Desc",
      provider_manual_applicability_description:
        "“Lesser of” language, Provider Manual applicability Desc",
      created_on: "Created On",
    };

    // Define the desired order of keys
    const desiredOrder = [
      "Effective_Date",
      "Provider_Name",
      "tax_id",
      "Submit_Claims",
      "participating_lines_of_business",
      "CPT_Code",
      "Description",
      "Rate",
      "cob_provision",
      "provider_name_effective_date",
      "submit_claims_description",
      "provider_manual_applicability_description",
      "created_on",
    ];

    // Reorder and rename the object keys
    const reorderedObj = Object.fromEntries(
      desiredOrder.map((key) => [keyMap[key] || key, obj[key]])
    );
    return reorderedObj;
  });

  return newArray;
}
